import { gql } from "@apollo/client";

export const publishOffer = gql`
  mutation PublishOffer($input: SetOfferPublishInput!) {
    publishOffer(input: $input) 
}
`;

export const unpublishOffer = gql`
  mutation UnpublishOffer($input: SetOfferPublishInput!) {
    unpublishOffer(input: $input)
  }
`;

export const acceptOfferParticipation = gql`
  mutation AcceptOfferParticipant($input: ApproveOfferParticipantInput!) {
    approveOfferParticipant(input: $input)
  }
`;

export const rejectOfferParticipation = gql`
  mutation RejectOfferParticipant($input: RejectOfferParticipantInput!) {
    rejectOfferParticipant(input: $input)
  }
`;

export const offerTransactionThread = gql`
  query OfferTransactionThread($input: OfferTransactionThreadInput!) {
  offerTransactionThread(input: $input) {
    uuid
    state
    message
    timeStamp
    sender_name
  }
}

`;



export const sendOfferParticipationMessage = gql`
mutation SendOfferParticipationMessageMutation($input: SendOfferParticipationMessage!) {
  sendOfferParticipationMessage(input: $input)
}

`